import React, { FC } from 'react';
import Alert from '@narvar/nth-block-alert';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import { TPanel } from '../types';

interface IProps {
  featureName?: string;
  panel: TPanel;
  onDismiss: () => void;
}

const PanelContainer: FC<IProps> = (props) => {
  const { panel, featureName, children, onDismiss } = props;

  const { panelcontainerNoneNone: panelcontainerStyle } = useTheme() as {
    [key: string]: React.CSSProperties;
  };

  const { marginBottom } = panelcontainerStyle ?? {};

  const handleDismiss = () => {
    onDismiss();
  };

  return (
    <div
      style={{
        display: panelcontainerStyle ? 'block' : 'none',
        paddingBottom: marginBottom ?? '0.5rem',
      }}
    >
      <Alert
        featureName={featureName}
        show
        dismissible={panel !== 'info'}
        dismissOnClick={handleDismiss}
      >
        {children}
      </Alert>
    </div>
  );
};

export default withThemeProvider(PanelContainer, {
  themeTokens: ['panelcontainerNoneNone'],
});
